import { RotatingEquipment } from "./RotatingEquipment";
export default RotatingEquipment;
